import Cookies from 'universal-cookie';
import Config from "./Config";
import StaticFunctions from "./StaticFunctions";

const cookieName = 'myZskFactorySid';
const apiTimeout = 55000;

class Api {

    static requestId = 1;
    static sid = null;

    constructor() {

        let conf = new Config();

        this.API_PATH = conf.getApiPath();

        this.cookies = new Cookies();

        this.cookieOptions = {
            'maxAge': conf.getCookieMaxAge()
        };

        // preset with cookie-data
        if (Api.sid === null) {
            Api.sid = this.cookies.get(cookieName);
        }

    }

    getRequestId() {

        return ++Api.requestId;

    }

    /**
     * @param {string} method
     * @param {object} params
     * @param {function} success
     * @param {function} error
     */
    request(method, params, success, error = null) {

        if (!method) return;

        if (!error) error = (e)=>{ console.error(e); };

        const request = {
            "id": this.getRequestId(),
            "method": method,
            "timeout": apiTimeout
        };

        if (!params) params = {};

        request.params = params;

        // If session exists - add session_id to params
        if (Api.sid) request.params.session_id = Api.sid;

        const reqString = JSON.stringify(request, null, '\t');

        try {
            const uri = this.API_PATH + '?m=' + method + '&ts=' + (new Date()).getTime();

            fetch(uri, {
                credentials: "same-origin",
                method: 'POST',
                body: reqString
            }).then(function(response) {
                return response.text();
            }).then(function(responseString) {
                const response = StaticFunctions.getJsonParse(responseString, {error: {message: "Request error: responseString is '" + responseString + "'"}});

                if (response.error) {
                    console.error("Error", response);

                    if (error) {
                        error(response);

                        return;
                    }

                    throw response.error.message;
                } else {
                    // new sid received
                    if (response.result && response.result.session_id) {
                        Api.sid = response.result.session_id;

                        this.cookies.set(cookieName, Api.sid, this.cookieOptions);
                    }

                    // Success - callback
                    if (success) {
                        success(response.result);
                    } else {
                        success = (ret) => console.debug(ret);
                    }
                }
            }.bind(this)).catch(function (e) {
                error(e);
            });
        }
        catch (e) {
            console.error(e);
        }

    }

    logout(logout = true) {

        this.cookies.set(cookieName, '');
        this.cookies.remove(cookieName);

        if (logout)
            logout = () => window.location.reload();
        else
            logout = null;

        this.request('Logout', null, logout);

    }

    fileSource(params) {

        let uri = this.API_PATH + 'file.php?';

        for (let ix in params) {
            uri += encodeURIComponent(ix);
            uri += '=';
            uri += encodeURIComponent(params[ix]);
            uri += '&';
        }

        uri += 'stamp=' + Date.now() + '&';
        uri += 'sid=' + Api.sid;

        return uri;

    }

}

export default Api;
